import { render, staticRenderFns } from "./blockGrid.vue?vue&type=template&id=42dc6abb&"
import script from "./blockGrid.vue?vue&type=script&lang=js&"
export * from "./blockGrid.vue?vue&type=script&lang=js&"
import style0 from "./blockGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports